import { Component, OnInit } from '@angular/core';
import { CommonMigFormComponent } from '../../components/abstract/common-mig-form.component';
import { Validators } from '@angular/forms';
import { createUrlTreeFromSnapshot } from '@angular/router';

@Component({
  selector: 'app-community-page',
  templateUrl: './community-page.component.html',
  styleUrls: ['./community-page.component.scss'],
})
export class CommunityPageComponent
  extends CommonMigFormComponent
  implements OnInit
{
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.module.step = 1;
    this.group = this.builder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      community: [null, [Validators.required]],
    });
    this.unsubscribe.push(
      this.module.onSubmit.subscribe(() => {
        console.log('onSubmit CommunityPageComponent');
        this.onSubmit();
      })
    );
    const storage = this.module.storage;
    if (storage) {
      this.group.patchValue(storage);
    }
  }

  onSubmit() {
    this.submit = true;
    this.group.markAsTouched();
    if (this.group.valid) {
      this.module.setStorage(this.group.getRawValue());
      this.module.initial$.next(this.group.getRawValue());
      const urlTree = createUrlTreeFromSnapshot(this.route.snapshot, [
        '../',
        'resident',
      ]);
      this.router.navigateByUrl(urlTree).then();
    }
  }
}
